<template>
  <v-container>
    <router-view />
  </v-container>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useMerchantStore } from '@/stores/merchant'

const props = defineProps({
  merchantIdent: {
    type: String,
    required: true,
    validator: function (value) {
      return /^[0-9a-f\-]{36}$/i.test(value)
    },
  },
})

const authStore = useAuthStore()
const merchantStore = useMerchantStore()

const currentMerchant = computed(() => authStore.currentMerchant)

onMounted(async () => {
  if (
    !currentMerchant.value.uuid ||
    currentMerchant.value.uuid != props.merchantIdent
  ) {
    await merchantStore.setCurrentFromIdent(props.merchantIdent)
    if (currentMerchant.value.uuid == props.merchantIdent) {
      merchantStore.showMerchantSelectModal({
        show: false,
        closable: true,
      })
    }
  }
})
</script>
